/** todo: accurately define these types
 * @typedef {Object} AjaxOptions
 * @property {any} params
 * @property {any} callback
 * @property {any} url
 * @property {any} ishtml
 * @property {any} isloader
 * @property {any} loadingButton
 * @property {any} loadingButtonStyle
 * @property {any} contentType
 * @property {any} contentTypeHelper
 * @property {any} cache
 * @property {any} processData
 * @property {any} cancelprevious
 * @property {any} delay
 * @property {any} preventResubmit
 */

(function ($) {
    const ajaxOutstanding = [],
        ajaxScheduled = [],
        progressBar = new Mprogress(),
        /** @type {AjaxOptions} */
        defaults = {
            params: null,
            callback: null,
            url: "",
            ishtml: false,
            isloader: true,
            loadingButton: null,    // jquery Object
            loadingButtonStyle: 'expand-right', // see: https://lab.hakim.se/ladda/
            contentType: 'application/json; charset=utf-8', //   for form submits, we want to use 'application/x-www-form-urlencoded; charset=UTF-8'
            contentTypeHelper: null, // overrides contentType if provided. Current supported values are: "json", "form"

            // for file upload, set contentType: false and the following to false
            cache: true,
            processData: true,

            // code flow management
            cancelprevious: false,  // Automatically cancel previous requests with the same signature
            delay: false,           // Wait [delay] seconds before executing request. If multiple requests with the same signature are made within the delay window, the delay is reset
            preventResubmit: false  // Prevent all future preventsubmit requests until this one is completed (note: non-preventsubmit requests can still go through)
        };
    let preventSubmit = false;

    $.fdAjax = function (opts) {
        const options = $.extend({}, defaults, opts);

        if (options.contentTypeHelper) {
            switch (options.contentTypeHelper.toLowerCase()) {
                case "json":
                    options.contentType = 'application/json; charset=utf-8';
                    break;
                case "form":
                    options.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
                    break;
            }
        }
        if (options.delay) {
            if (isNaN(options.delay)) {
                options.delay = 500;
            }
            handleAjaxSchedule(options);
        } else {
            return handleAjax(options);
        }
    };

    function handleAjaxQueue(url, ajaxCall) {
        for (let i = ajaxOutstanding.length - 1; i >= 0; i--) {
            const ajaxObj = ajaxOutstanding[i];

            //  remove any done calls
            if (ajaxObj.xhr.readyState === 4) {
                ajaxOutstanding.splice(i, 1);
                if (ajaxOutstanding.length === 0) {
                    progressBar.end();
                }
                continue;
            }

            //  if there's a repeat, kill the previous
            if (ajaxObj.url === url) {
                ajaxObj.xhr.abort();
                ajaxOutstanding.splice(i, 1);
                if (ajaxOutstanding.length === 0) {
                    progressBar.end();
                }
            }
        }

        ajaxOutstanding.push({
            url: url,
            xhr: ajaxCall
        });
    }


    function handleAjaxSchedule(options) {
        for (let i = ajaxScheduled.length - 1; i >= 0; i--) {
            if (ajaxScheduled[i].name === options.url) {
                clearTimeout(ajaxScheduled[i].timeout);
                ajaxOutstanding.splice(i, 1);
                if (ajaxOutstanding.length === 0) {
                    progressBar.end();
                }
            }
        }

        ajaxScheduled.push({
            name: options.url,
            timeout: setTimeout(function () {
                handleAjax(options);
            }, options.delay)
        });
    }


    function cleanupAfterAjax(options, laddaButton) {
        if (options.isloader) {
            progressBar.end();
        }
        if (laddaButton) {
            laddaButton.stop();
            laddaButton.remove();
        }
        if (options.preventResubmit) {
            preventSubmit = false;
        }
    }

    function handleAjax(options) {
        if (options.preventResubmit) {
            if (preventSubmit) {
                return;
            }

            preventSubmit = true;
        }
        options.defer = $.Deferred();
        let laddaButton;
        if (options.loadingButton) {
            if (!options.loadingButton.hasClass('ladda-button')) {
                options.loadingButton.addClass('ladda-button').attr('data-style', options.loadingButtonStyle).append('<span class="ladda-spinner"></span>');
            }
            laddaButton = Ladda.create(options.loadingButton[0]);
            laddaButton.start();
        }

        var ajaxCall = $.ajax({
            url: options.url,
            async: options.async === undefined ? true : options.async,
            data: (options.contentType === 'application/json; charset=utf-8') ? JSON.stringify(options.params) : options.params,
            type: 'POST',
            dataType: options.ishtml ? "html" : "json",
            contentType: options.params instanceof FormData ? false :  options.contentType,
            cache: options.cache,
            processData: options.processData,
            beforeSend: function () {
                if (options.isloader) {
                    progressBar.start();
                }
            }
        }).done(function (data) {
            cleanupAfterAjax(options, laddaButton);
            options.data = data;
            options.success = true;

            if (typeof options.callback === 'function') {
                options.callback(options);
            } else {
                options.defer.resolve(options.data);
            }
        }).fail(function (jqXhR, textStatus, errorThrown) {
            cleanupAfterAjax(options, laddaButton);
            options.dataError = jqXhR;
            options.errorStatus = textStatus;
            options.errorMsg = errorThrown;
            if (typeof options.callback === 'function') {
                if (errorThrown !== "abort") {
                    options.callback.call(options, false);
                }
            } else {
                options.defer.reject(options);
            }
            if (typeof FD.Utility.onFailure === 'function') {
                if (jqXhR.status === 0) {
                    return;
                }

                FD.Utility.onFailure(jqXhR, this, options);
            }
        });

        if (options.cancelprevious) {
            handleAjaxQueue(options.url, ajaxCall);
        }

        return options.defer.promise();
    }
}(jQuery));